import { isPageAtTop, getScrollTop } from "../utility/utility.js";

class ServiceMenu extends HTMLElement {
  constructor() {
    super();
    this.serviceMenu = this.querySelector(".js-service-menu");
    this.lastScrollPosition = 0;
    this.serviceMenu.setAttribute("aria-expanded", "false");
    this.dispatchEvent(new CustomEvent("serviceMenu:opened", { bubbles: true }));
    this.dispatchEvent(new CustomEvent("serviceMenu:closed", { bubbles: true }));
  }

  connectedCallback() {
    window.addEventListener("scroll", () => this.handleScroll());
    this.handleInitialScrollPosition();
    this.initDropdownToggleListeners();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", () => this.handleScroll());
  }

  handleScroll() {
    const currentScrollPosition = getScrollTop();
    if (isPageAtTop() || this.isDropdownOpen() || currentScrollPosition < this.lastScrollPosition) {
      this.serviceMenu.classList.add("service-open");
      this.serviceMenu.classList.remove("service-closed");
      this.serviceMenu.setAttribute("aria-expanded", "true");
      this.serviceMenu.setAttribute("aria-hidden", "false");
    } else {
      this.serviceMenu.classList.remove("service-open");
      this.serviceMenu.classList.add("service-closed");
      this.serviceMenu.setAttribute("aria-expanded", "false");
      this.serviceMenu.setAttribute("aria-hidden", "true");
    }
    this.lastScrollPosition = currentScrollPosition;
  }

  handleInitialScrollPosition() {
    this.handleScroll();
  }

  isDropdownOpen() {
    return !!document.querySelector(".main-nav__dropdown.is-open");
  }

  initDropdownToggleListeners() {
    const toggles = document.querySelectorAll(".js-toggle-mega-nav");

    toggles.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        this.serviceMenu.classList.add("service-open");
        this.serviceMenu.classList.remove("service-closed");
        this.serviceMenu.setAttribute("aria-expanded", "true");
        this.serviceMenu.setAttribute("aria-hidden", "false");
      });
    });
  }
}

customElements.define("nabohjaelp-service-menu", ServiceMenu);
